<template>
  <base-entity-card
    :id="id"
    titleName="отзыва"
    :saveFunc="save"
    :loading="loading"
    @closed="restoreEntity"
    :oneColumn="true"
  >
    <v-form ref="form" v-model="isValid">
      <v-autocomplete
        label="Сайт"
        v-model="entity.site"
        :items="sitesSelectData"
        clearable
        filled
      ></v-autocomplete>
      <v-text-field
        label="Имя клиента *"
        v-model="entity.customerName"
        :rules="[v => !!v || 'Введите имя.']"
        filled
      ></v-text-field>
      <v-text-field
        label="Название объекта *"
        v-model="entity.objectName"
        :rules="[v => !!v || 'Введите имя.']"
        filled
      ></v-text-field>
     
      <site-testimonials-cities-data
        :activeMode="isActiveCitiesForm"
        v-model="entity.cityBuildings"
        @closeForm="isActiveCitiesForm = false"
      ></site-testimonials-cities-data>
      <files-table
        :smIndex="12"
        label="Скан отзыва"
        :singleFile="true"
        v-model="entity.photo"
        :key="filesId"
      ></files-table>
      
    </v-form>
  </base-entity-card>
</template>

<script>
import { getTempId } from '../../../models/common';
import SiteEntityMixin from '../../../models/SiteEntityMixin';
import SiteTestimonialsCitiesData from './SiteTestimonialCitiesData';

export default {
  name: 'site-testimonial-card',

  mixins: [SiteEntityMixin],

  components: {
    SiteTestimonialsCitiesData
  },

  data() {
    return {
      tag: 'testimonial',
      isActiveCitiesForm: false,
      filesId: getTempId()
    }
  },

  methods: {
    getDefaultEntity() {
      this.filesId = getTempId();
      return {
        site: null,
        customerName: '',
        objectName: '',
        photo: [],
        cityBuildings: null
      }
    },
  },
}
</script>